var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
var weekDay = ["Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön" ];
var weekDayAdjust = ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör" ];


class DateTime
{
    static formatDate(dateString, format)
    {
        const date = this.getUTCDate(dateString);

        switch (format)
        {
            case 'hh:mm':
                return this.getTime(date);
            case 'yyyy-mm-dd':
                return this.getDate(date);
            case 'yyyy-mm-dd hh:mm':
                return `${this.getDate(date)} ${this.getTime(date)}`;
            default:
                return `${this.getDate(date)} ${this.getTime(date)}`;
        }
    }

    static getUTCDate(dateString)
    {
        // replace - with / in dateString for browser compatibility.
        dateString = dateString.replace(/-/g, "/");

        // Entries that come via socket have a date then a dot followed by a 6 digit number that should not be in the date
        dateString = dateString.split('.')[0];

        /*
        * The date we get from the server is UTC time.
        * We need to add UTC to the end of date_created
        * so that the Date function will convert it to
        * the UTC time that the browser is using.
        */
        const dateStringUTC = dateString + ' UTC';

        return new Date(dateStringUTC);
    }

    static getTime(date)
    {
        const hours = this.padDate(date.getHours());
        const minutes = this.padDate(date.getMinutes());
        return `${hours}:${minutes}`;
    }

    static getDate(date)
    {
        const year = date.getFullYear();
        const month = this.padDate(date.getMonth() + 1);
        const day = this.padDate(date.getDate());
        return `${year}-${month}-${day}`;
    }

    static padDate(number)
    {
        number = String(number);

        if (number.length === 1)
        {
            number = `0${number}`;
        }

        return number;
    }

    static isToday(dateString)
    {
        const date = this.getUTCDate(dateString);

        const today = new Date();

        return today.toDateString() === date.toDateString();
    }

    static getNiceDate(dateString) {
        const date = this.getUTCDate(dateString);
        const today = new Date()
        if (this.isToday(dateString))
            return 'Idag';

        const weekDate = date.getDay()
        const month = date.getMonth()

          var timeDiff = Math.abs(today.getTime() - date.getTime());
          var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
          if (diffDays === 1)
              return "Igår";
          if (diffDays < 7)
              return `${weekDayAdjust[weekDate]}`;

        return `${date.getDate()} ${monthNames[month]} ${date.getFullYear()}`;
    }
    static getDiffFromToday(dateString){
        const date = this.getUTCDate(dateString);
        const today = new Date()
        var timeDiff = Math.abs(today.getTime() - date.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

        return `${diffDays}`;

    }

    static getDiffTime(here, there){
        let hereDate = this.getUTCDate(here);
        let thereDate = this.getUTCDate(there);
        return Math.abs(hereDate - thereDate);
    }


    static getDiffSecond(here, there){
        return Math.ceil(this.getDiffTime(here,there)/(1000));
    }

    static getDiffMinutes(here, there){
        return Math.ceil(this.getDiffTime(here,there)/(1000*60));
    }
    static getDiffHours(here, there){
        return Math.ceil(this.getDiffTime(here,there)/(1000*3660));
    }
    static getDiffDays(here, there){
        return Math.ceil(this.getDiffTime(here, there)/(1000*3660*24));
    }

    static getDetailedNiceDate(dateString) {
        const date = this.getUTCDate(dateString);
        const today = new Date()
        if (this.isToday(dateString))
            return this.getTime(date);
        const weekDate = date.getDay()
        const month = date.getMonth()

        var timeDiff = Math.abs(today.getTime() - date.getTime());
        var diffDays = timeDiff / (1000 * 3600 * 24);
        if (diffDays < 2)
            return "Igår " + this.getTime(date);
        if (diffDays < 7) {
            return `${weekDayAdjust[weekDate]} ${this.getTime(date)}`;
        }

        return `${date.getDate()} ${monthNames[month]} ${this.getTime(date)}`;

    }
    static convertSecondsToHour(seconds){
        const hour = Math.floor(seconds / 3600);
        const minut = Math.floor((seconds - hour*3600)/60);
        const second = seconds - hour*3600  - minut*60;
        let time = ''
        if(hour) time += hour + 'tim'
        if(minut) time+= ' ' + minut + 'min'
        if(second) time+= ' ' + second + 'sec'
        return time
    }
    static convertMinutesToHour(minutes){
        let time = []
        const hour = Math.floor(minutes / 60);
        const minut = minutes - hour*60;
        hour? time.push(hour): time.push(0)
        minut? time.push(minut): time.push(0)
        return time
    }


    static arrayToWeekDates(lst){
        if(!lst){
            return 'nothing here'
        }
        if(lst.size === 7){
            return 'Alla'
        }

        let days= weekDay[parseInt(lst[0], 10)]
        for(var i = 1; i < lst.length; i++){
            days += ',' + weekDay[parseInt(lst[i], 10)]
        }

        return days
    }

}

export default DateTime;



// WEBPACK FOOTER //
// src/lib/DateTime.js